import clsx from 'clsx';
import { FC } from 'react';
import styles from './AuctionAlert.module.scss';
import { AuctionAlertType } from './AuctionAlertTypeEnum';

const AuctionAlertBase: FC<{
  type: AuctionAlertType;
  children: React.ReactNode;
}> = ({ type, children }) => {
  return (
    <div className={clsx(styles.alert, styles[`alert--${type}`])}>
      {children}
    </div>
  );
};

const AuctionAlertIcon: FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  return <div className={styles['alert__icon']}>{children}</div>;
};

const AuctionAlertContent: FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  return <div className={styles['alert__content']}>{children}</div>;
};

export const AuctionAlert = Object.assign(AuctionAlertBase, {
  Icon: AuctionAlertIcon,
  Content: AuctionAlertContent,
});
